var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.131 0 0 3.13 0 7s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7m0 13.023A6.03 6.03 0 0 1 .977 7 6.03 6.03 0 0 1 7 .977 6.03 6.03 0 0 1 13.023 7 6.03 6.03 0 0 1 7 13.023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.835c-.414 0-.71.175-.71.433v3.51c0 .222.296.443.71.443.397 0 .72-.221.72-.442V6.268c0-.258-.323-.433-.72-.433M7 3.67c-.424 0-.755.304-.755.654s.331.664.755.664c.415 0 .747-.314.747-.664S7.415 3.67 7 3.67"
  })));
};
export default SvgInfo;